// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  margin-bottom: 0;
  padding-bottom: 0;
  color: #111111;
}

h2.ngorange {
  color: #007566;
}

.sticky .panelHr {
  margin: 10px;
}

.attention {
  background-color: #007566;
  padding: 2px 4px;
  color: #111111;
  border-radius: 3px;
}

.infoTable {
  width: 100%;
}

.name {
  font-size: 1.4rem;
  margin: 0;
  padding: 0;
}

.graph-container h3 {
  margin-top: 12px;
}

.concordanceResults {
  margin-top: 15px;
}

.analysisTabs {
  margin-top: -2px;
}

.analysisTabs h2 {
  font-size: 1.4rem;
  padding-top: 15px;
}

::ng-deep .analysisTabs .mat-tab-header {
  border-bottom: 1px solid #bcbcbc;
}

::ng-deep .analysisTabs .mat-tab-label {
  font-size: 1.15rem;
  padding: 0 10px;
}

::ng-deep .analysisTabs.rightMatchesTabs .mat-tab-body {
  max-height: unset;
}

::ng-deep .analysisTabs .mat-expansion-panel .mat-expansion-panel-header.cdk-keyboard-focused:not([aria-disabled=true]), ::ng-deep .analysisTabs .mat-expansion-panel .mat-expansion-panel-header.cdk-program-focused:not([aria-disabled=true]), ::ng-deep .analysisTabs .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]) {
  background: transparent;
}

::ng-deep .personTd .mat-expansion-panel .mat-expansion-panel-header.cdk-keyboard-focused:not([aria-disabled=true]), ::ng-deep .personTd .mat-expansion-panel .mat-expansion-panel-header.cdk-program-focused:not([aria-disabled=true]), ::ng-deep .personTd .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]) {
  background: transparent;
}

::ng-deep .analysisTabs .mat-expansion-panel:not([class*=mat-elevation-z]),
::ng-deep .personTd .mat-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: none;
}

::ng-deep .analysisTabs .mat-expansion-panel-header,
::ng-deep .personTd .mat-expansion-panel-header {
  padding: 0;
}

::ng-deep .analysisTabs .mat-expansion-panel-header-description,
::ng-deep .analysisTabs .mat-expansion-panel-header-title,
::ng-deep .personTd .mat-expansion-panel-header-description {
  margin: 0;
  font-size: 1.2rem;
}

::ng-deep .personTd .mat-expansion-panel-header-title {
  color: #111111;
  margin: 0;
  font-size: 1.2rem;
}

::ng-deep .analysisTabs .mat-content {
  max-width: 107px;
}

::ng-deep .personTd .mat-content {
  max-width: 129px;
}

::ng-deep .analysisTabs .mat-tab-label-container {
  overflow-x: auto !important;
}

::ng-deep .analysisTabs .mat-expansion-panel-body,
::ng-deep .personTd .mat-expansion-panel-body {
  border: 1px #bcbcbc solid;
  padding-top: 10px;
  font-size: 1.3rem;
}

::ng-deep .analysisTabs .mat-expansion-panel-body h3,
::ng-deep .personTd .mat-expansion-panel-body h3 {
  font-size: 1.3rem;
}

.fullView-wrapper-scrollfix-correction {
  padding-top: 0px;
}

.legend {
  margin-top: 8px;
  margin-bottom: 8px;
}

#legendUp tr td:nth-child(odd) {
  padding-right: 8px;
}

#legendUp tr td:nth-child(even) {
  padding-bottom: 4px;
  padding-right: 8px;
}

#legendDown tr td:nth-child(odd) {
  padding-left: 6px;
  padding-right: 8px;
}

#legendUp tr td:nth-child(even) {
  padding-bottom: 2px;
}

.colorTitle {
  width: 100%;
  padding: 4px;
}

.graphTitle {
  padding-top: 4px;
  padding-left: 5px;
}

.countTitle {
  color: white;
  font-size: 1.3em;
  font-family: sans-serif;
  font-weight: bold;
  padding-left: 10px;
  padding-top: 12px;
}

.subCircleTitle {
  padding-top: 5px;
}

.personTitle {
  width: 220px;
  color: white;
  font-size: 1.2em;
  padding-top: 12px;
  padding-right: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.listsNames {
  padding-top: 2px;
}

.nameListing {
  padding: 20px;
  background-color: white;
}

.nameBox {
  padding-top: 4px;
  border-bottom: 1px solid #ddd;
}

.fakeItem {
  background-color: #EDF2F5;
  line-height: 12px;
}

.buttonTitle {
  padding-right: 10px;
  margin-top: 2px;
}

.icon-inline {
  display: inline-block !important; /* override any block defaults */
  vertical-align: top !important; /* center it on the text */
  margin-right: 0.3em; /* a little breathing room */
}

.box {
  border: 4px solid #ddd;
  padding: 20px;
  margin-bottom: 15px;
}

.button {
  margin-top: 10px;
  padding: 10px;
  color: white;
  text-align: center;
  background: #666;
  cursor: pointer;
}
.button.btn-new-ibt {
  padding: 10px 20px;
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 25px;
}

.button:hover {
  background: #777;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/jobSatisfactions/components/mobile/mobile-job-satisfactions-report/mobile-job-satisfactions-report.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,iBAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAMQ;EACI,uBAAA;AAHZ;;AAYQ;EACI,uBAAA;AATZ;;AAcA;;EAEI,gBAAA;AAXJ;;AAcA;;EAEI,UAAA;AAXJ;;AAcA;;;EAGI,SAAA;EACA,iBAAA;AAXJ;;AAcA;EACI,cAAA;EACA,SAAA;EACA,iBAAA;AAXJ;;AAcA;EACI,gBAAA;AAXJ;;AAcA;EACI,gBAAA;AAXJ;;AAcA;EACI,2BAAA;AAXJ;;AAcA;;EAEI,yBAAA;EACA,iBAAA;EACA,iBAAA;AAXJ;;AAcA;;EAEI,iBAAA;AAXJ;;AAcA;EACI,gBAAA;AAXJ;;AAcA;EACI,eAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,kBAAA;AAXJ;;AAcA;EACI,mBAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,iBAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,mBAAA;AAXJ;;AAcA;EACI,WAAA;EACA,YAAA;AAXJ;;AAcA;EACI,gBAAA;EACA,iBAAA;AAXJ;;AAcA;EACI,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAXJ;;AAcA;EACI,gBAAA;AAXJ;;AAcA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AAXJ;;AAcA;EACI,gBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,uBAAA;AAXJ;;AAcA;EACI,gBAAA;EACA,6BAAA;AAXJ;;AAcA;EACI,yBAAA;EACA,iBAAA;AAXJ;;AAcA;EACI,mBAAA;EACA,eAAA;AAXJ;;AAcA;EACI,gCAAA,EAAA,gCAAA;EACA,8BAAA,EAAA,0BAAA;EACA,mBAAA,EAAA,4BAAA;AAXJ;;AAcA;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;AAXJ;;AAcA;EACI,gBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAXJ;AAaI;EACI,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACC,mBAAA;AAXT;;AAeA;EACI,gBAAA;EACA,eAAA;AAZJ","sourcesContent":["h2 {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    color: #111111;\n}\n\nh2.ngorange {\n    color: #007566;\n}\n\n.sticky .panelHr {\n    margin: 10px;\n}\n\n.attention {\n    background-color: #007566;\n    padding: 2px 4px;\n    color: #111111;\n    border-radius: 3px;\n}\n\n.infoTable {\n    width: 100%;\n}\n\n.name {\n    font-size: 1.4rem;\n    margin: 0;\n    padding: 0;\n}\n\n.graph-container h3 {\n    margin-top: 12px;\n}\n\n.concordanceResults {\n    margin-top: 15px;\n}\n\n.analysisTabs {\n    margin-top: -2px;\n}\n\n.analysisTabs h2 {\n    font-size: 1.4rem;\n    padding-top: 15px;\n}\n\n::ng-deep .analysisTabs .mat-tab-header {\n    border-bottom: 1px solid #bcbcbc;\n}\n\n::ng-deep .analysisTabs .mat-tab-label {\n    font-size: 1.15rem;\n    padding: 0 10px;\n}\n\n::ng-deep .analysisTabs.rightMatchesTabs .mat-tab-body {\n    max-height: unset;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel {\n    & .mat-expansion-panel-header.cdk-keyboard-focused,\n    & .mat-expansion-panel-header.cdk-program-focused,\n    &:not(.mat-expanded) .mat-expansion-panel-header:hover {\n        &:not([aria-disabled='true']) {\n            background: transparent;\n        }\n    }\n}\n\n::ng-deep .personTd .mat-expansion-panel {\n    & .mat-expansion-panel-header.cdk-keyboard-focused,\n    & .mat-expansion-panel-header.cdk-program-focused,\n    &:not(.mat-expanded) .mat-expansion-panel-header:hover {\n        &:not([aria-disabled='true']) {\n            background: transparent;\n        }\n    }\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel:not([class*=mat-elevation-z]),\n::ng-deep .personTd .mat-expansion-panel:not([class*=mat-elevation-z]) {\n    box-shadow: none;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel-header,\n::ng-deep .personTd .mat-expansion-panel-header {\n    padding: 0;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel-header-description,\n::ng-deep .analysisTabs .mat-expansion-panel-header-title,\n::ng-deep .personTd .mat-expansion-panel-header-description {\n    margin: 0;\n    font-size: 1.2rem;\n}\n\n::ng-deep .personTd .mat-expansion-panel-header-title {\n    color: #111111;\n    margin: 0;\n    font-size: 1.2rem;\n}\n\n::ng-deep .analysisTabs .mat-content {\n    max-width: 107px;\n}\n\n::ng-deep .personTd .mat-content {\n    max-width: 129px;\n}\n\n::ng-deep .analysisTabs .mat-tab-label-container {\n    overflow-x: auto !important;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel-body,\n::ng-deep .personTd .mat-expansion-panel-body {\n    border: 1px #bcbcbc solid;\n    padding-top: 10px;\n    font-size: 1.3rem;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel-body h3,\n::ng-deep .personTd .mat-expansion-panel-body h3 {\n    font-size: 1.3rem;\n}\n\n.fullView-wrapper-scrollfix-correction {\n    padding-top: 0px;\n}\n\n.legend {\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n#legendUp tr td:nth-child(odd) {\n    padding-right: 8px;\n}\n\n#legendUp tr td:nth-child(even) {\n    padding-bottom: 4px;\n    padding-right: 8px;\n}\n\n#legendDown tr td:nth-child(odd) {\n    padding-left: 6px;\n    padding-right: 8px;\n}\n\n#legendUp tr td:nth-child(even) {\n    padding-bottom: 2px;\n}\n\n.colorTitle {\n    width: 100%;\n    padding: 4px;\n}\n\n.graphTitle {\n    padding-top: 4px;\n    padding-left: 5px;\n}\n\n.countTitle {\n    color: white;\n    font-size: 1.3em;\n    font-family: sans-serif;\n    font-weight: bold;\n    padding-left: 10px;\n    padding-top: 12px\n}\n\n.subCircleTitle {\n    padding-top: 5px\n}\n\n.personTitle {\n    width: 220px;\n    color: white;\n    font-size: 1.2em;\n    padding-top: 12px;\n    padding-right: 10px;\n    width: fit-content;\n}\n\n.listsNames {\n    padding-top: 2px\n}\n\n.nameListing {\n    padding: 20px;\n    background-color: white;\n}\n\n.nameBox {\n    padding-top: 4px;\n    border-bottom: 1px solid #ddd;\n}\n\n.fakeItem {\n    background-color: #EDF2F5;\n    line-height: 12px;\n}\n\n.buttonTitle {\n    padding-right: 10px;\n    margin-top: 2px;\n}\n\n.icon-inline {\n    display: inline-block !important;   /* override any block defaults */\n    vertical-align: top !important;   /* center it on the text */\n    margin-right: 0.3em;                 /* a little breathing room */\n}\n\n.box {\n    border: 4px solid #ddd;\n    padding: 20px;\n    margin-bottom: 15px;\n}\n\n.button {\n    margin-top: 10px;\n    padding: 10px;\n    color: white;\n    text-align: center;\n    background: #666;\n    cursor: pointer;\n\n    &.btn-new-ibt {\n        padding: 10px 20px;\n        width: fit-content;\n         margin-bottom: 25px;\n    }\n}\n\n.button:hover {\n    background: #777;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
